import { AUTH_LOGIN_METHOD_STORAGE_KEY, AUTH_OTP_SMS_FALLBACK_SECONDS } from '@/constants/auth/login';
import type { AuthLoginMethod, AuthOtpCooldownState } from '@/interfaces/AuthLogin';

export const sanitizeAuthLoginMethod = (value: string | null | undefined): AuthLoginMethod => (value === 'qr' ? 'qr' : 'otp');

export const getStoredAuthLoginMethod = (storageValue: string | null | undefined): AuthLoginMethod => sanitizeAuthLoginMethod(storageValue);

export const getAuthLoginMethodStorageKey = () => AUTH_LOGIN_METHOD_STORAGE_KEY;

export const getOtpCooldownState = ({
    nowMs,
    requestedAtMs,
    waitSeconds = AUTH_OTP_SMS_FALLBACK_SECONDS,
}: {
    nowMs: number;
    requestedAtMs: number | null;
    waitSeconds?: number;
}): AuthOtpCooldownState => {
    if (requestedAtMs === null) {
        return {
            canContinue: true,
            secondsRemaining: 0,
        };
    }

    const elapsedMs = Math.max(0, nowMs - requestedAtMs);
    const remainingSeconds = Math.max(0, Math.ceil(waitSeconds - elapsedMs / 1000));

    return {
        canContinue: remainingSeconds === 0,
        secondsRemaining: remainingSeconds,
    };
};
